import React from 'react';
import {Button, Stack, Typography} from '@mui/material';
import {IconIllustration, CTAButtonFixed} from 'presentation/components';
import {useCallChatRoom, useMediaQueries} from 'presentation/pages/private';
import {ChatRoomsEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {ResponsiveCard} from '../ResponsiveCard';

const {alreadyPreRegistered} = translations['pt-br'].others.facialBiometric;

export function AlreadyPreRegisteredCard() {
	const {isTablet} = useMediaQueries();
	const {callChatRoom} = useCallChatRoom();

	async function handleTalkToSupport() {
		await callChatRoom(ChatRoomsEnum.SAC);
	}

	return (
		<>
			<ResponsiveCard>
				<Stack
					alignItems="center"
					gap={2}
					textAlign="center"
					justifyContent="center"
					pt={8}>
					<IconIllustration variant="info" customIconName="info-filled" />
					<Typography variant="h6">{alreadyPreRegistered.title}</Typography>
					<Typography variant="body1">{alreadyPreRegistered.description}</Typography>

					{!isTablet && (
						<Button onClick={handleTalkToSupport} sx={{marginTop: 6}}>
							{alreadyPreRegistered.button}
						</Button>
					)}
				</Stack>
			</ResponsiveCard>

			{isTablet ? (
				<CTAButtonFixed.Root $isTablet={isTablet} sx={{bottom: 0}}>
					<CTAButtonFixed.Action onClick={handleTalkToSupport} fullWidth>
						{alreadyPreRegistered.button}
					</CTAButtonFixed.Action>
				</CTAButtonFixed.Root>
			) : null}
		</>
	);
}
